import { render } from "./OptimizedManifestMap.vue?vue&type=template&id=746924b0&scoped=true"
import script from "./OptimizedManifestMap.vue?vue&type=script&lang=js"
export * from "./OptimizedManifestMap.vue?vue&type=script&lang=js"

import "./OptimizedManifestMap.vue?vue&type=style&index=0&id=746924b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746924b0"]])

export default __exports__